export default "__VITE_ASSET__Bh07GLbF__"